<div class="gauge-chart-wrapper">
  <div class="gauge-title">
    {{ "malignancyRate" | translate }}
  </div>

  <div class="gauge-body">
    <div class="position-relative">
      <!-- Gradient Bar -->
      <div class="gradient">
        <!-- Pointer -->
        <div class="pointer" [ngStyle]="{ left: formatGaugeRate }">
        </div>
      </div>

      <!-- Labels -->
      <div class="linear-gauge">
        <div class="linear-gauge-section low">{{ "low" | translate }}</div>
        <div class="linear-gauge-section moderate">{{ "moderate" | translate }}</div>
        <div class="linear-gauge-section high">{{ "high" | translate }}</div>
      </div>
    </div>
  </div>
</div>